import { NS_GS } from "../core/utils/constants";

export const RESOURCE_CONFIGURATION = {
    "inDataset": {
        "displayName": "In Dataset",
        "colour": "#212121",
        "iri": NS_GS + "inDataset"
    }
};

